import { render } from "./MSidebarSubFeatures.vue?vue&type=template&id=8a741206&scoped=true"
import script from "./MSidebarSubFeatures.vue?vue&type=script&lang=js"
export * from "./MSidebarSubFeatures.vue?vue&type=script&lang=js"

import "./MSidebarSubFeatures.vue?vue&type=style&index=0&id=8a741206&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a741206"]])

export default __exports__